module.exports = __webpack_public_path__ + "img/coupon_tutorial_romakyun03.dbb2785a.png";